module.exports = __webpack_public_path__ + "static/media/adjustable_dollar2.9aa1a91c.png";